import React from 'react'
import styles from './school-head-title.styles'
import injectSheet from 'react-jss'
import HeadTitle from '../../head-title/head-title'

const SchoolHead = ({ classes, title, className }) => (
  <HeadTitle className={className}>{title}</HeadTitle>
)

export default injectSheet(styles)(SchoolHead)
